import React from "react";
import "./sidebar.css";
import logo from "../images/logo3.png";
import { Link } from "react-router-dom";

import { FiMenu ,FiHome} from "react-icons/fi";
import { FaRegFolderOpen, FaCloudUploadAlt, FaShareAlt, FaStar, FaTrashAlt } from "react-icons/fa";
import { FaFolderTree } from "react-icons/fa6";
import { FiSettings } from "react-icons/fi";

const Sidebar = ({ active, setActive, isOpen, setIsOpen }) => {
  
const menuItems = [
  { id: 0, name: "Home", path: "/main/home", icon: <FiHome /> },
  { id: 1, name: "My Cloud", path: "/main/mycloud", icon: <FaRegFolderOpen /> },
  { id: 3, name: "Channels", path: "/main/channels", icon: <FaFolderTree /> },
  { id: 5, name: "Favorites", path: "/main/favorites", icon: <FaStar /> },
  { id: 6, name: "Trash", path: "/main/trash", icon: <FaTrashAlt /> },
  { id: 7, name: "Settings", path: "/main/settings", icon: <FiSettings /> },
];

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>

      {/* BRAND LOGO + NAME */}
      <div className="brand">
        <img src={logo} alt="logo" className="brand-logo" />
        {isOpen && <h2 className="brand-name">CommitNexus</h2>}
      </div>

      {/* MENU LIST */}
      <div className="menu-section">
        {menuItems.map((item) => (
          <Link 
            to={item.path} 
            style={{textDecoration:"none"}}
            className={`sidebar-item ${active === item.id ? "active" : ""}`}
            onClick={() => setActive(item.id)}
          >
            <span className="icon">{item.icon}</span>
            {isOpen && <span className="text">{item.name}</span>}
          </Link>
        ))}
      </div>

      {/* TOGGLE BUTTON AT BOTTOM */}
      <div className="bottom-toggle">
        <FiMenu 
          className="menu-btn" 
          onClick={() => setIsOpen(!isOpen)}
        />
        {isOpen && <span className="toggle-text">Collapse</span>}
      </div>
    </div>
  );
};

export default Sidebar;
